import { Link } from "react-router-dom";
import { Facebook, Twitter, Instagram, Linkedin, Mail, Phone, MapPin } from "lucide-react";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0f172a] text-white" data-testid="footer">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {/* Brand */}
          <div>
            <div className="font-bold text-2xl mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Local<span className="text-[#f97316]">Tradies</span>Online
            </div>
            <p className="text-slate-400 mb-4">
              Australia's most trusted tradie directory. Connect with verified, insured professionals for all your home and business needs.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-slate-400 hover:text-[#f97316] transition-colors" aria-label="Facebook">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="text-slate-400 hover:text-[#f97316] transition-colors" aria-label="Twitter">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="text-slate-400 hover:text-[#f97316] transition-colors" aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="text-slate-400 hover:text-[#f97316] transition-colors" aria-label="LinkedIn">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold text-lg mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/browse" className="text-slate-400 hover:text-[#f97316] transition-colors">Find Tradies</Link></li>
              <li><Link to="/get-quote" className="text-slate-400 hover:text-[#f97316] transition-colors">Get a Quote</Link></li>
              <li><Link to="/join" className="text-slate-400 hover:text-[#f97316] transition-colors">Join as Tradie</Link></li>
              <li><a href="#" className="text-slate-400 hover:text-[#f97316] transition-colors">How It Works</a></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-bold text-lg mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>Popular Services</h3>
            <ul className="space-y-2">
              <li><Link to="/browse?service=electrician" className="text-slate-400 hover:text-[#f97316] transition-colors">Electricians</Link></li>
              <li><Link to="/browse?service=plumber" className="text-slate-400 hover:text-[#f97316] transition-colors">Plumbers</Link></li>
              <li><Link to="/browse?service=painter" className="text-slate-400 hover:text-[#f97316] transition-colors">Painters</Link></li>
              <li><Link to="/browse?service=builder" className="text-slate-400 hover:text-[#f97316] transition-colors">Builders</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-bold text-lg mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2 text-slate-400">
                <Phone className="w-5 h-5 mt-0.5 flex-shrink-0" />
                <span>0431 775 771</span>
              </li>
              <li className="flex items-start space-x-2 text-slate-400">
                <Mail className="w-5 h-5 mt-0.5 flex-shrink-0" />
                <span>hello@localtradiesonline.com.au</span>
              </li>
              <li className="flex items-start space-x-2 text-slate-400">
                <MapPin className="w-5 h-5 mt-0.5 flex-shrink-0" />
                <span>Nationwide Coverage<br />All States & Territories</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8">
          {/* Lionheart Digital Branding - Minimal */}
          <div className="flex flex-col items-center text-center mb-4">
            <div className="flex items-center gap-2 mb-1">
              <img 
                src="https://static.prod-images.emergentagent.com/jobs/28a7e231-ff1b-4b8f-915f-47798802b078/images/2fa9ddf7953c616448f48ed011e225e9e3469523a5a5c8f53c562308f1d829cc.png" 
                alt="Lionheart Digital" 
                className="h-4 w-auto"
              />
              <div>
                <span className="text-xs font-medium text-white">LIONHEART</span>
                <span className="text-xs font-medium text-orange-500"> DIGITAL</span>
              </div>
            </div>
            <p className="text-[10px] italic text-slate-600">
              "They lit the fire. We became it."
            </p>
          </div>
          
          <div className="text-center text-slate-400 text-sm">
            <p>&copy; {currentYear} LocalTradiesOnline.com.au. A Lionheart Digital Asset.</p>
            <div className="flex justify-center space-x-6 mt-3">
              <Link to="/privacy" className="hover:text-[#f97316] transition-colors">Privacy Policy</Link>
              <Link to="/terms" className="hover:text-[#f97316] transition-colors">Terms of Service</Link>
              <Link to="/cookies" className="hover:text-[#f97316] transition-colors">Cookie Policy</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};